import { render } from "./GameDisplay.vue?vue&type=template&id=39fd2fb4&scoped=true"
import script from "./GameDisplay.vue?vue&type=script&lang=js"
export * from "./GameDisplay.vue?vue&type=script&lang=js"

import "./GameDisplay.vue?vue&type=style&index=0&id=39fd2fb4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39fd2fb4"

export default script